import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { getSessionUrl } from '../../ApiCalls/axiosClient';


const ProfileSettings = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const menuStyle = {
    backgroundColor: '#1A1A1A',
    color: 'white',
    padding: '20px',
    fontFamily: 'Arial, sans-serif',
    minHeight: '100vh',
    width: '100%',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  };

  const sectionStyle = {
    marginBottom: '40px',
    padding: '16px',
    borderRadius: '16px',
    backgroundColor: "#252525"
  };

  const sectionTitleStyle = {
    fontSize: '18px',
    fontWeight: 'bold',
    marginBottom: '20px',
  };

  const menuItemStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '15px 0',
    cursor: 'pointer',
  };

  const chevronStyle = {
    fontSize: '24px',
    color: '#FFE016',
  };

  function handleLogout() {
    // localStorage.removeItem('token');
    // localStorage.removeItem('ctx');
    // localStorage.removeItem('dx');
    // localStorage.removeItem('time');
    // localStorage.removeItem('uid');
    // localStorage.removeItem('rmsid');
    // const nextYear = new Date();
    // const currentD = new Date();
    // nextYear.setFullYear(currentD.getFullYear() + 1);
    // localStorage.setItem('uid_exp', 1, { path: '/', expires: nextYear });
    const redirectURL = getSessionUrl();
    localStorage.clear();
    window.location.href = redirectURL;
    return;
  }

  function handleUnsub() {
    navigate("/unsubscribe");
  }

  useEffect(() => {
    document.title = "Settings | BingeBit";
  }, [])


  return (
    <div style={menuStyle}>
      <div style={sectionTitleStyle}>{t('support')} </div>
      <div style={sectionStyle}>
        {/* <div style={menuItemStyle} onClick={() => navigate('/avatar-changes')}>
          <span>Early Avatar Changes</span>
          <span style={chevronStyle}>›</span>
        </div> */}
        <div style={menuItemStyle} onClick={() => navigate('/faqs')}>
          <span>{t('faqs')}</span>
          <span style={chevronStyle}>›</span>
        </div>
      </div>
      <div style={sectionTitleStyle}>{t('more_information')}</div>

      <div style={sectionStyle} onClick={() => navigate('/terms-service')}>
        <div style={menuItemStyle}>
          <span>{t('terms_of_service')}</span>
          <span style={chevronStyle}>›</span>
        </div>
      </div>

      <div style={sectionTitleStyle}>{t('account_actions')}</div>
      <div style={sectionStyle}>
        {/* <div style={menuItemStyle} onClick={handleUnsub}>
          <span>{t('unsubscribe')}</span>
          <span style={chevronStyle}>›</span>
        </div> */}
        <div style={menuItemStyle} onClick={handleLogout}>
          <span>{t('logout')}</span>
          <span style={chevronStyle}>›</span>
        </div>
      </div>
    </div>
  );
};

export default ProfileSettings;